import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import { BUYER_INTENT, DATA_ENRICHMENT, FORM_SHORTENING } from 'self-service-api/constants/Features';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import { FeatureAvailableIcon } from '../feature-table/SharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IconMessage = ({
  message
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    alignItems: "center",
    flexBasis: "50%",
    marginBlockStart: "200",
    flexWrap: "nowrap",
    children: [/*#__PURE__*/_jsx(View, {
      marginInlineEnd: "200",
      children: /*#__PURE__*/_jsx(FeatureAvailableIcon, {
        padding: "100"
      })
    }), /*#__PURE__*/_jsx(Text, {
      whiteSpace: "nowrap",
      as: "p",
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: message
      })
    })]
  });
};
const BreezeIntelligenceStarterPlatformBanner = ({
  trackingSource
}) => {
  const handleLinkClick = () => {
    trackClickedLink({
      type: 'internal',
      url: '/suite',
      trackingSource,
      value: 'Starter Customer Platform'
    });
  };
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "400",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      typography: "heading-400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.breezeStarterCustomerPlatformCard.title"
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "merchCards.breezeStarterCustomerPlatformCard.description_jsx",
        elements: {
          br: 'br',
          Link: UIRouterLink
        },
        options: {
          to: createToObject('/suite'),
          onClick: handleLinkClick
        }
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      justifyContent: "space-between",
      flexWrap: "wrap",
      children: [[DATA_ENRICHMENT, BUYER_INTENT, FORM_SHORTENING].map(feature => /*#__PURE__*/_jsx(IconMessage, {
        message: `pricingPage.pages.breezeIntelligence.keyFeatures.features.${feature}.title`
      }, feature)), /*#__PURE__*/_jsx(IconMessage, {
        message: "merchCards.breezeStarterCustomerPlatformCard.everyStarterProduct"
      })]
    })]
  });
};
export default BreezeIntelligenceStarterPlatformBanner;